// ./src/contexts/VenuesContext/VenuesContext.tsx
import React, { createContext, useContext } from "react";

import { useRoomTypes, UseRoomTypesReturn, UseRoomTypesOptions } from "@/hooks";

export interface RoomTypesContextValue extends UseRoomTypesReturn {
  // Additional context-specific methods if needed in the future
}

export interface RoomTypesProviderProps {
  children: React.ReactNode;
  options?: UseRoomTypesOptions;
}

const RoomTypesContext = createContext<RoomTypesContextValue | undefined>(
  undefined
);

export const RoomTypesProvider: React.FC<RoomTypesProviderProps> = ({
  children,
  options = {},
}) => {
  const roomTypesHook = useRoomTypes(options);

  return (
    <RoomTypesContext.Provider value={roomTypesHook}>
      {children}
    </RoomTypesContext.Provider>
  );
};

// Custom hook for using the venues context
export const useRoomTypesContext = (): RoomTypesContextValue => {
  const context = useContext(RoomTypesContext);

  if (context === undefined) {
    throw new Error(
      "useRoomTypesContext must be used within a RoomTypesProvider"
    );
  }
  return context;
};
